import React, { memo } from "react";
import { FormProvider } from "react-hook-form";
import RightModalLayout from "../../../layouts/Modal/RightModalLayout";
import ButtonMC from "../../../components/ButtonMC";
import LoadingMC from "../../../components/LoadingMC";
import { useWhatsappFlowResponses } from "../hooks/useWhatsappFlowResponses";
import WhatsappFlowMessageAndMappingConfig from "./WhatsappFlowMessageAndMappingConfig";

const WhatsappFlowMappingModal = memo(({ flow, onSaved }) => {
  const {
    t,
    loading,
    saving,
    saveToCustomerState,
    mappings,
    closeModal,
    handleAddMapping,
    handleRemoveMapping,
    handleToggleSaveToCustomer,
    handleSaveMapping,
    customerFieldsOptions,
    newFlowKey,
    setNewFlowKey,
    newCustomerField,
    setNewCustomerField,
    availableFlowKeysOptions,
    availableCustomerFieldsOptions,
    defaultHeaderText,
    setDefaultHeaderText,
    defaultFlowCta,
    setDefaultFlowCta,
    defaultBodyText,
    setDefaultBodyText,
    defaultFooterText,
    setDefaultFooterText,
    methods
  } = useWhatsappFlowResponses(flow, "mapping", onSaved);

  return (
    <FormProvider {...methods}>
      <RightModalLayout
        title={`${flow.name}`}
        caption={t('responses_caption')}
        closeAction={closeModal}
        footerVariant="NONE"
        className="!tw-p-0 !tw-space-y-0"
      >
        <>
          <div className="tw-overflow-y-auto tw-flex-1">
            {loading ? (
              <LoadingMC loading className="tw-py-20" />
            ) : (
              <WhatsappFlowMessageAndMappingConfig
                t={t}
                defaultHeaderText={defaultHeaderText}
                setDefaultHeaderText={setDefaultHeaderText}
                defaultBodyText={defaultBodyText}
                setDefaultBodyText={setDefaultBodyText}
                defaultFooterText={defaultFooterText}
                setDefaultFooterText={setDefaultFooterText}
                defaultFlowCta={defaultFlowCta}
                setDefaultFlowCta={setDefaultFlowCta}
                saveToCustomerState={saveToCustomerState}
                handleToggleSaveToCustomer={handleToggleSaveToCustomer}
                mappings={mappings}
                customerFieldsOptions={customerFieldsOptions}
                newFlowKey={newFlowKey}
                setNewFlowKey={setNewFlowKey}
                newCustomerField={newCustomerField}
                setNewCustomerField={setNewCustomerField}
                availableFlowKeysOptions={availableFlowKeysOptions}
                availableCustomerFieldsOptions={availableCustomerFieldsOptions}
                handleAddMapping={handleAddMapping}
                handleRemoveMapping={handleRemoveMapping}
              />
            )}
          </div>

          {!loading && (
            <div className="tw-px-2 tw-py-6 tw-bg-white tw-flex tw-justify-end tw-flex-shrink-0">
              <ButtonMC
                text={t('save_configuration')}
                onClick={handleSaveMapping}
                loading={saving}
                variant="PRIMARY"
              />
            </div>
          )}
        </>
      </RightModalLayout>
    </FormProvider>
  );
});

WhatsappFlowMappingModal.displayName = "WhatsappFlowMappingModal";

export default WhatsappFlowMappingModal;
